module.exports = __webpack_public_path__ + "img/masoutis_front.1eb8e152.png";